<template>
  <div id="eqSetting">
    <div class="back">
      <div class="body">
        <div style="color:#000000;font-size:16px;">
            <el-button type="primary" size="small" @click="pullData" style="margin-left: 15px;position: absolute; right: 100px;">
              <i class="el-icon-upload"></i>{{$t('equipmentmanagement.read')}}
            </el-button>
        </div>
        <div class="bodyback">
          <div style="text-align: left;margin-left: 20px">
            <el-switch
              style="display: block"
              v-model="isCurrentData"
              active-color="#F4A460"
              inactive-color="#DCDCDC"
              active-value=1
              inactive-value=2
              :active-text="$t('equipmentmanagement.historicalData')"
              :inactive-text="$t('equipmentmanagement.currentData')">
            </el-switch>
          </div>
          <div v-if="isCurrentData==2" style="text-align: left;margin-left: 20px;margin: 20px 0 20px 20px">
            <span>{{$t('equipmentmanagement.totalSalesNumberOfCups')}}：{{totalCount}}</span>
            <span style="margin-left: 40px">{{$t('equipmentmanagement.totalSalesAmount')}}：{{totalAmount}}</span>
          </div>
          <div v-if="isCurrentData==2" class="bodyback">
            <div class="c1" v-for="(item,index1) in drinks" :key="index1">
              <div v-for="(item2,index2) in item" :key="index2" style="height:190px">
                <div class="drinkback" :class="{noneback:!item2.cup,q1back:item2.cup&&item2.cupquantity==1,q2back:item2.cup&&item2.cupquantity==2,q3back:item2.cup&&item2.cupquantity==3}" >
                  <img v-if="item2.cup&&item2.cup.beverage&&item2.cup.beverage.picture" :src="$prefix+item2.cup.beverage.picture.path" class="dinkpic">
                  <img v-else-if="item2.cup!=null&&item2.cup.beverage.picture==null" src="@/assets/images/nopic.png" class="nopic">
                </div>
                  <div  class="cname" v-if="item2.cup&&item2.cup.beverage">{{item2.cup.beverage.name}}</div>
                  <div class="cname" v-if="item2.cup&&item2.cup.cupSize">{{item2.cup.cupSize.name}}</div>
                <div v-if="item2.cup" style="color:#777777">{{$t('homepage.salesNumberOfCups')}}：{{item2.count}}</div>
              </div>
            </div>
          </div>
          <div v-if="isCurrentData==1" style="text-align: left;margin-left: 20px;margin: 20px 0 20px 20px">
            <span>{{$t('equipmentmanagement.totalSalesNumberOfCups')}}：{{hisTotalCount}}</span>
            <span style="margin-left: 40px">{{$t('equipmentmanagement.totalSalesAmount')}}：{{hisTotalAmount}}</span>
          </div>
          <div v-if="isCurrentData==1" style="overflow-y:scroll;height:780px">
            <div v-for="(item,index) in hisArr" :key="index" style="width: 25%;height: 190px;float: left" v-if="item&&item.cupType">
              <div class="drinkback">
                <img v-if="item&&item.cupType&&item.cupType.beverage&&item.cupType.beverage.picture" :src="'https://icloud.lhcoffeetime.com/'+item.cupType.beverage.picture.path" class="dinkpic">
              </div>
              <div  class="cname" v-if="item&&item.cupType&&item.cupType.beverage">{{item.cupType.beverage.name}}</div>
              <div class="cname" v-if="item&&item.cupType&&item.cupType.cupSize">{{item.cupType.cupSize.name}}</div>
              <div v-if="item&&item.cupType" style="color:#777777">{{$t('homepage.salesNumberOfCups')}}：{{item.count}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  props:
    ['initvalue']
  ,
  name:"EquipmentButtomConfig",
  data() {
    return {
      isCurrentData:1,// 是否是当前数据1是2不是
      allvisible:false,
      isFree:true,
      allpowder:[],
      selectedpowder:[],
      equipmentRecordsList:new Object(),
      powderindex:-1,
      powderid:-1,
      drinks:[
        [{cupquantity:null,totalCount:1.00,cup:null,count:0},{cupquantity:null,totalCount:1.00,cup:null,count:0},{cupquantity:null,totalCount:1.00,cup:null,count:0},{cupquantity:null,totalCount:1.00,cup:null,count:0}],
        [{cupquantity:null,totalCount:1.00,cup:null,count:0},{cupquantity:null,totalCount:1.00,cup:null,count:0},{cupquantity:null,totalCount:1.00,cup:null,count:0},{cupquantity:null,totalCount:1.00,cup:null,count:0}],
        [{cupquantity:null,totalCount:1.00,cup:null,count:0},{cupquantity:null,totalCount:1.00,cup:null,count:0},{cupquantity:null,totalCount:1.00,cup:null,count:0},{cupquantity:null,totalCount:1.00,cup:null,count:0}],
        [{cupquantity:null,totalCount:1.00,cup:null,count:0},{cupquantity:null,totalCount:1.00,cup:null,count:0},{cupquantity:null,totalCount:1.00,cup:null,count:0},{cupquantity:null,totalCount:1.00,cup:null,count:0}]
      ],
      historydrink:[[]],
      cupvisible:false,
      cupid:-1,
      cupquantity: 1,
      cupindex1:-1,
      cupindex2:-1,
      BtnConfigList:[],
      price:'0.00',
      totalBtnConfigCount:0,
      totalCount:0,
      totalAmount:0,
      hisTotalCount:0,
      hisTotalAmount:0,
      hisArr:[]
    }
  },
  mounted() {
    this.loadBtnConfigListQC();

  },
  methods:{
    //获取按键信息
    loadBtnConfigListQC(){
      let that = this;
      this.$httpservice.get("api/Equipment/KeyConfigs",{dtuNo:that.initvalue.dtuNumber}).then(
        (data) =>{
          if(data.body.code=="200"){
            that.BtnConfigList = data.body.data;
            let list =  that.BtnConfigList.filter(item=>{return item.cupType})
            //console.log(list)
            if(list && list.length>0){
              for(let i in list){
                let sort = list[i].sort-1
                let index1 = sort%4
                let index2 = Math.floor(sort/4)
                //console.log(list[i])
                that.selectedpowder[index2] = list[i].cupType.beverage.rawMaterials[0]
                that.drinks[index2][index1].cupquantity = 1;
                //that.drinks[index2][index1].price = list[i].price;
                that.drinks[index2][index1].cup = list[i].cupType;
                that.$forceUpdate()
              }
            }
            that.loadEquipmentRecords();
          }else{
            that.$message({
              message: data.body.msg,
              type: 'danger'
            });
          }
        },
        function (data) {
          let statusCode = data.status;
          that.$message({
            message: that.$t('queryFailedStatusCode')+statusCode,
            type: 'warning'
          });
        }
      );
    },
    pullData(){
          let that = this;
          this.$httpservice.get("api/EquipmentOperation/ReadEquipmentStatisticalData?equipmentId="+that.initvalue.id).then(
            function (data) {
                if(data.body.code=="200"){
                    that.$message({
                        message: that.$t('equipmentmanagement.readingSuccessfully')+"！",
                        type: 'success'
                    });
                }else{
                    that.$message({
                        message: data.body.msg,
                        type: 'warning'
                    });
                }
            },
            function (data) {
                let statusCode = data.status;
                that.$message({
                    message: that.$t('queryFailedStatusCode')+statusCode,
                    type: 'warning'
                });
            }
          );
    },
    //获取记录
    loadEquipmentRecords(){
      let that = this;
      return this.$httpservice.get("api/Equipment/EquipmentRecords?equipmentId="+that.initvalue.id).then(
        function (data) {
          if(data.body.code=="200"){
            let hisCount = 0
            let hisAmount = 0
            that.equipmentRecordsList = data.body.data;

            let arr = that.equipmentRecordsList.equipmentRecords.filter(x=>x.current==0);
            // 算当前机器的总销售额
            let tempTotalAmount = 0
            arr.filter(x => {
              tempTotalAmount += x.totalAmount
            })

            that.hisArr = that.equipmentRecordsList.equipmentRecords.filter(x=>x.current==1);
            // 计算总杯数和总金额
            that.hisArr.filter(item =>{
              if(item.cupType){
                hisCount +=  item.count
                hisAmount += item.totalAmount
              }
            })
            let tempTotalCount = 0;
            for(var i=0;i<that.drinks.length;i++){
              for(var j=0;j<that.drinks[i].length;j++){
                if(that.drinks[i][j].cup!=null){
                  //console.log(that.drinks[i][j].cup)
                  if(that.drinks[i][j].cup.beverage!=undefined){
                    let sortnumber = i*4 + j+1;
                    that.totalCount = that.equipmentRecordsList.totalCount;
                    that.totalAmount = that.equipmentRecordsList.totalAmount;
                    let filterdata = that.equipmentRecordsList.equipmentRecords.filter(x=>x.cupType!=null)
                    if(filterdata){
                      filterdata = filterdata.filter(x=>x.cupType.id==that.drinks[i][j].cup.id);
                      filterdata = filterdata.filter(x=>x.cupType.beverage.id==that.drinks[i][j].cup.beverage.id);
                    }

                    if(filterdata.length >0 && filterdata[0].current == 1){
                      that.drinks[i][j].count = filterdata[0].count;
                      tempTotalCount += filterdata[0].count
                    }
                  }
                }
              }
            }
            that.hisTotalCount = hisCount
            that.hisTotalAmount = hisAmount
            that.totalCount = tempTotalCount
            that.totalAmount = tempTotalAmount
          }else{
            that.$message({
              message: data.body.msg,
              type: 'warning'
            });
          }
        },
        function (data) {
          let statusCode = data.status;
          that.$message({
            message: that.$t('queryFailedStatusCode')+statusCode,
            type: 'warning'
          });
        }
      );
    },

  }
}
</script>
<style scoped lang="less">
#eqSetting{
  .back{
    padding: 20px;
    background: url("../../assets/images/equipment/background_pay.jpg");
    background-size: 100% 100%;
    text-align: center;
  }

  .body{
    display: inline-block;
    width: 60%;
    input{
      .el-input__inner{
        text-align: center!important;
      }
    }
  }
  .headback{
    background: url("../../assets/images/equipment/back_material.jpg");
    background-size: 100% 100%;
    overflow: hidden;
    padding: 10px 0px;
  }
  .c1{
    float: left;
    width: 25%;
    text-align: center;
  }
  .c2{
    float: left;
    width: 20%;
    text-align: center;
    position: relative;
    margin-bottom: 20px;
  }

  .c1 img,.c2 img{
    width: 100px;
  }
  .cname{
    display: inline-block;
    width: 110px;
    line-height: 25px;
    color: #2e2115;
    background-size: 100% 100%;
    font-size: 12px;
  }
  .cnameyuan{
    margin-top: 10px;
    display: inline-block;
    width: 70px;
    font-size: 12px;
    height: 25px!important;
  }
  .powderlist{
    overflow: hidden;
    max-height: 500px;
    overflow-y: auto;
  }
  .checked{
    position: absolute;
    left: 20px;
    top: 0px;
    width: 20px!important;
    height: 20px!important;
  }
  .checked2{
    position: absolute;
    right: -10px;
    top: 5px;
    width: 20px!important;
    height: 20px!important;
  }
  .bodyback{
    padding: 20px 0;
    background-color: #f7ebe1;
    overflow: hidden;
    height: 900px;
  }

  .drinkback{
    width: 100px;
    height: 100px;
    /* margin-bottom: 20px; */
    display: inline-block;
    cursor: pointer;
  }
  .noneback{
    background-size: 100% 100%;
  }
  .q1back{
    background: url("../../assets/images/equipment/background_normal.png");
    background-size: 100% 100%;
  }
  .q2back{
    background: url("../../assets/images/equipment/background_bold.png");
    background-size: 100% 100%;
  }
  .q3back{
    background: url("../../assets/images/equipment/background_more_bold.png");
    background-size: 100% 100%;
  }
  .quantity{
    display: inline-block;
    line-height: 30px;
    vertical-align: top;
    margin-right: 20px;
    width: 60px;
    text-align: center;
    background-size: 100% 100% !important;
    color: #fff;
    cursor: pointer;
    position: relative;
  }
  .q1{
    background: url("../../assets/images/equipment/background_normal.png");
  }
  .q2{
    background: url("../../assets/images/equipment/background_bold.png");
  }
  .q3{
    background: url("../../assets/images/equipment/background_more_bold.png");
  }
  .dinkpic{
    display: inline-block;
    width: 80px!important;
    height: 80px!important;
    display: inline-block;
    margin-top: 10px;
  }

  .nopic{
    display: inline-block;
    width: 50px!important;
    height: 50px!important;
    display: inline-block;
    margin-top: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/equipmentmanagement/CupStatistics.vue